module.exports = __webpack_public_path__ + "img/credit_card.6f381d7a.png";